import { converter } from '@/uteis/converters'

export const tratarCamposDataTable = (item, column, converterName, setValue) => {
  if (setValue) {
    return { value: setValue }
  }

  let valor = item

  if (!column) {
    return { value: valor }
  }

  const atributos = column.split('.')

  for (var i = 0; i < atributos.length; i++) {
    if (atributos[i].indexOf('[') === -1) {
      if (valor[atributos[i]]) {
        valor = valor[atributos[i]]
      } else {
        valor = ''
      }
    } else {
      valor = { valor: valor, atributo: atributos[i] }
      break
    }
  }

  return converterName ? converter(converterName, valor) : { value: valor }
}
